<template>
  <div
    class="containuiw"
    v-if="list"
    v-loading="loading"
    element-loading-text="拼命加载中"
  >
    <!-- 倒计时 -->
    <div class="time-top">
      <div class="contain-top">
        <div class="date-box">
          <span class="span">倒计时：{{ count_min }}:{{ count_sec }}</span>
        </div>
        <div class="bt">
          <el-button class="save" type="primary" size="medium " @click="save"
            >交卷</el-button
          >
        </div>
      </div>
    </div>
    <div
      class="big-list"
      v-for="(item, index) in list.answer_snap ? list.answer_snap.snap : []"
      :key="index"
    >
      <!-- 选择题 -->
      <div
        class="big"
        v-if="
          item.student_question_bank ? item.student_question_bank.type == 1 : ''
        "
      >
        <div class="contain-center">
          <div class="contain-center-top">
            {{ index + 1 }}.单选题<span>（{{ item.score }}分）</span>
          </div>
          <div
            class="contain-center-title"
            v-html="item.student_question_bank.title"
          ></div>
          <div class="contain-center-check">
            <el-radio-group
              class="radio"
              v-model="form.answers[index].student_answer_content"
            >
              <el-radio
                class="miniRadio"
                v-for="(items, indexs) in item.student_question_bank.option"
                :key="indexs"
                :label="items.name + indexs"
                >{{ items.content }}</el-radio
              >
            </el-radio-group>
          </div>
        </div>
      </div>
      <!-- 多选题 -->
      <div
        class="big"
        v-else-if="
          item.student_question_bank ? item.student_question_bank.type == 2 : ''
        "
      >
        <div class="contain-center">
          <div class="contain-center-top">
            {{ index + 1 }}.多选题<span>（{{ item.score }}分）</span>
          </div>
          <div
            class="contain-center-title"
            v-html="item.student_question_bank.title"
          ></div>
          <div class="contain-center-check">
            <el-checkbox-group
              class="radio"
              v-model="form.answers[index].student_answer_content"
            >
              <el-checkbox
                class="miniRadio"
                v-for="(items, indexs) in item.student_question_bank.option"
                :key="indexs"
                :label="items.name + indexs"
              >
                {{ items.content }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <!-- 填空题 -->
      <div
        class="big"
        v-else-if="
          item.student_question_bank ? item.student_question_bank.type == 3 : ''
        "
      >
        <div class="contain-center">
          <div class="contain-center-top">
            {{ index + 1 }}.填空题 <span>（{{ item.score }}分）</span>
          </div>
          <div
            class="contain-center-title"
            v-html="item.student_question_bank.title"
          ></div>
          <div class="contain-center-content">
            <div
              class="contain-center-content-box"
              v-for="(v, i) in item.student_question_bank.title.split('_____')
                .length - 1"
              :key="i"
            >
              <span>答案{{ i + 1 }}：</span
              ><el-input
                v-model="form.answers[index].student_answer_content[i]"
                clearable
                style="width: 200px"
                placeholder="请输入答案"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <!-- 简答题 -->
      <div
        class="big"
        v-else-if="
          item.student_question_bank ? item.student_question_bank.type == 4 : ''
        "
      >
        <div class="contain-center">
          <div class="contain-center-top">
            {{ index + 1 }}.简答题<span>（{{ item.score }}分）</span>
          </div>
          <div
            class="contain-center-title"
            v-html="item.student_question_bank.title"
          ></div>
          <div class="textarea">
            <el-input
              v-if="show == false"
              style="border: none"
              type="textarea"
              :rows="5"
              placeholder="在此写下你的解答。"
              v-model="form.answers[index].student_answer_content"
            >
            </el-input>
          </div>
        </div>
      </div>
      <!-- 判断题 -->
      <div
        class="big"
        v-else-if="
          item.student_question_bank ? item.student_question_bank.type == 5 : ''
        "
      >
        <div class="contain-center">
          <div class="contain-center-top">
            {{ index + 1 }}.判断题<span>（{{ item.score }}分）</span>
          </div>
          <div
            class="contain-center-title"
            v-html="item.student_question_bank.title"
          ></div>
          <div class="contain-center-check">
            <div
              class="contain-center-check-left"
              style="display: flex; margin-top: 30px"
            >
              <div
                class="contain-center-checkbox"
                :class="
                  item.student_question_bank.judge == 1
                    ? 'contain-center-checkbox-check'
                    : ''
                "
                style="margin-right: 20px"
                @click="checkJudge(1, '正确', index)"
              >
                <i class="el-icon-success" style="margin-right: 10px"></i> 正确
              </div>
              <div
                class="contain-center-checkbox"
                :class="
                  item.student_question_bank.judge == 2
                    ? 'contain-center-checkbox-check'
                    : ''
                "
                @click="checkJudge(2, '错误', index)"
              >
                <i class="el-icon-error" style="margin-right: 10px"></i> 错误
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p v-if="noMore && !noData">已经到底了~</p>
    <noData v-if="noData && !loading"></noData>
  </div>
</template>
<script>
import request from "@/utils/request";
import Cookies from "js-cookie";
import noData from "@/components/noData/index.vue";
export default {
  components: { noData },
  data() {
    return {
      show: false,
      active: -1,
      query: {
        teacher_paper_id: "",
        limit: 10,
      },
      list: [],
      total: 0,
      form: {
        log_id: "",
        answers: [],
      },
      minutes: 90,
      seconds: 0,
      judge: null,
      value: [],
      //倒计时时间
      count_day: "00",
      count_hour: "00",
      count_min: "00",
      count_sec: "00",
      timer: null,
      loading: true,
      noData: false,
      noMore: false,
    };
  },
  created() {
    if (Cookies.get("Admin-Token")) {
      this.query.teacher_paper_id = this.$route.query.teacher_paper_id;
      this.getSubjectList();
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll); // 监听（绑定）滚轮滚动事件
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
  },
  methods: {
    checkJudge(key, answer, index) {
      console.log(key, answer, index);
      // this.judge=key
      this.list.answer_snap.snap[index].student_question_bank.judge = key;
      this.form.answers[index].student_answer_content = answer;
      this.$forceUpdate(); //强制更新
    },
    handleScroll() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        if (!this.noMore) {
          console.log("触底");
          return;
          this.query.limit += 10;
          this.getSubjectList();
        }
        // else{
        //   this.query.limit += 10;
        //   this.getSubjectList();
        // }
        //写后台加载数据的函数
        // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
      }
    },
    //倒计时
    countdown(endtime) {
      let that = this;
      that.timer = setInterval(() => {
        var downTime = parseInt(
          new Date(endtime.replace(/-/g, "/")).getTime() - new Date().getTime()
        );
        if (downTime <= 0) {
          that.count_min = "00";
          that.count_sec = "00";
          clearInterval(that.timer);
          let obj = JSON.parse(JSON.stringify(this.form));
          obj.answers.forEach((item, i) => {
            if (this.list.answer_snap.snap[i].student_question_bank.type == 2) {
              item.student_answer_content.sort();
              item.student_answer_content =
                item.student_answer_content.toString();
            }
            if (item.student_answer_content instanceof Array) {
              item.student_answer_content =
                item.student_answer_content.toString();
            }
          });
          request({
            url: "/api/userend/paper/commitTest",
            method: "post",
            data: obj,
          }).then((response) => {
            this.$message.success("提交成功");
            this.$router.go(-1); //返回上一层
          });
          return;
        } else {
          var d = parseInt(downTime / 1000 / 3600 / 24);
          var h = parseInt((downTime / 1000 / 3600) % 24);
          var m = parseInt((downTime / 1000 / 60) % 60);
          var s = parseInt((downTime / 1000) % 60);

          d < 10 ? (d = "0" + d) : d;
          h < 10 ? (h = "0" + h) : h;
          m < 10 ? (m = "0" + m) : m;
          s < 10 ? (s = "0" + s) : s;

          that.count_min = m;
          that.count_sec = s;
        }
      }, 1000);
    },
    // 提交试卷
    save() {
      this.$confirm("提交后不可修改，是否确认提交？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // console.log('=========1');
          // //点击确定的操作(调用接口)
          // console.log(this.form);
          let obj = JSON.parse(JSON.stringify(this.form));
          obj.answers.forEach((item, i) => {
            if (this.list.answer_snap.snap[i].student_question_bank.type == 1) {
              item.student_answer_content =
                item.student_answer_content.toString();
            }
            if (this.list.answer_snap.snap[i].student_question_bank.type == 2) {
              item.student_answer_content.sort();
              item.student_answer_content =
                item.student_answer_content.toString();
            }
            if (item.student_answer_content instanceof Array) {
              item.student_answer_content =
                item.student_answer_content.toString();
            }
          });
          console.log(this.form);
          request({
            url: "/api/userend/paper/commitTest",
            method: "post",
            data: obj,
          }).then((response) => {
            this.$message.success("提交成功");
            this.$router.go(-1); //返回上一层
          });
        })
        .catch(() => {
          //几点取消的提示
        });
    },
    check(index) {
      this.active = index;
    },
    // 获取题目
    getSubjectList() {
      this.loading = true;
      this.noData = false;
      request({
        url: "/api/userend/paper/startTest",
        method: "post",
        params: this.query,
      }).then((response) => {
        this.list = response.data;
        this.form.log_id = response.data.id;
        this.total = response.data.answer_snap.question_num;
        let length = response.data.answer_snap.snap.length;
        // 判断列表是否为空
        if (length == 0) {
          this.noData = true;
        }
        // 下拉加载更多判断是否还有
        if (length < this.query.limit) {
          this.noMore = true;
        }
        // 将填空题的标题中的{input}转化为_____
        this.list.answer_snap.snap.forEach((item, index) => {
          // 将选择题的选项从字符串转为数组对象
          item.student_question_bank.option = JSON.parse(
            item.student_question_bank.option
          );
          // 判断是否为选择题，是的话将答案类型转为数组，否的话转为字符串。
          if (item.student_question_bank.type == 2) {
            this.form.answers.push({
              index: index,
              student_answer_content: [],
            });
          } else if (item.student_question_bank.type == 3) {
            // 将填空题的标题中的{input}转化为_____
            item.student_question_bank.title =
              item.student_question_bank.title.replaceAll("{input}", "_____");
            // 答案类型转为数组
            this.form.answers.push({
              index: index,
              student_answer_content: [],
            });
          } else {
            // 答案类型转为字符串
            this.form.answers.push({
              index: index,
              student_answer_content: "",
            });
          }
        });
        // 获取答题倒计时
        this.countdown(
          this.$moment(response.data.expire_at).format("YYYY-MM-DD HH:mm:ss")
        );
        // 答题回显
        if (this.list.answer_snap.snap[0].student_answer_content != null) {
          this.list.answer_snap.snap.forEach((item, index) => {
            if (item.student_question_bank.type == 3) {
              let arr = item.student_answer_content.split(","); //逗号是分隔符
              console.log(arr, "arr");
              arr.forEach((v, i) => {
                this.form.answers[index].student_answer_content[i] = arr[i];
                console.log(
                  this.form.answers[index].student_answer_content,
                  "this.form.answers[index].student_answer_content"
                );
              });
            } else {
              this.form.answers[index].student_answer_content =
                item.student_answer_content;
            }
          });
        }
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss">
.el-checkbox {
  font-size: 20px;
  .el-checkbox__inner {
    width: 20px;
    height: 20px;
    &::after {
      // font-size: 10px;
      height: 10.2px;
      width: 4.6px;
      left: 6.4px;
    }
  }
  .el-checkbox__label {
    font-size: 20px;
  }
}
.containuiw {
  width: 100%;
  padding: 30px;
  min-height: calc(100vh - 160px);
  background: #ffffff;
  border-radius: 9px;
  overflow: hidden;
  .time-top {
    z-index: 99;
    width: 74.3%;
    padding: 30upx 30upx;
    position: fixed;
    top: 80px;
    right: 0;
    height: 18px;
    background: #f9fafd;
    .contain-top {
      z-index: 9;
      position: fixed;
      top: 98px;
      width: 73%;
      margin: 0 auto;
      background: #ffffff;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #f9fafd;
      .date-box {
        padding: 10px 30px;
        .span {
          margin-left: 30upx;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #506176;
        }
      }
      .bt {
        padding: 10px 30px;
        .save {
        }
      }
    }
  }
  p {
    text-align: center;
  }
  .big-list {
    margin-top: 20px;
    .big {
      padding: 30px 0;
      border-bottom: 1px solid #f9fafd;
      .contain-center {
        .contain-center-top {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #506176;
          span {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #506176;
            margin-left: 20px;
          }
        }
        .contain-center-title {
          margin-top: 20px;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 34px;
        }
        .contain-center-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .img {
            width: 120px;
            height: 102px;
            margin-left: 140px;
          }
          .contain-center-content-box {
            margin-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            span {
              margin-right: 10px;
            }
          }
        }
        .textarea {
          margin-top: 36px;
          .el-textarea__inner {
            border: none;
          }
          .img-box {
            .img {
              width: 120px;
              height: 102px;
              margin-left: 140px;
            }
          }
        }
        .contain-center-check {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .el-radio {
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }
          .el-radio__inner {
            width: 25px;
            height: 25px;
          }
          .el-radio__label {
            font-size: 20px;
          }
          .radio {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .miniRadio {
              margin-top: 20px;
            }
          }
          .img {
            width: 120px;
            height: 102px;
            margin-left: 140px;
          }
          .contain-center-check-left {
            .contain-center-check-box {
              cursor: pointer;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              padding: 25px 0;
              img {
                width: 20px;
                height: 20px;
                border-radius: 50%;
              }
              span {
                margin-left: 17px;
                font-size: 20px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }
            }
          }
        }
        .contain-center-btn {
          margin-top: 45px;
        }
      }
      .contain-bottom {
        margin-top: 20px;
        .contain-bottom-top {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #506176;
        }
        .contain-bottom-success {
          margin-top: 15px;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          span {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #f24342;
          }
        }
        .contain-bottom-msg {
          margin-top: 12px;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 31px;
        }
      }
    }
  }
}
.contain-center-check {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .img {
    width: 120px;
    height: 102px;
    margin-left: 140px;
  }
  .contain-center-check-left {
    .contain-center-check-box {
      cursor: pointer;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 16px 0;
      img {
        width: 20px;
        height: 20px;
        border-radius: 50%;
      }
      span {
        margin-left: 17px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }
    .contain-center-checkbox {
      width: 105px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #cccccc;
      border-radius: 8px;
      color: #999999;
      font-size: 20px;
      cursor: pointer;
    }
    .contain-center-checkbox-check {
      border-color: red;
      color: red;
    }
  }
}
</style>